import { useState } from "react";

import axios from "axios";

import { DEFAULT_RECIPE_CREATION_IMAGE_LINK, IMAGE_GENERATION_API, RECIPE_CREATION_TIMEOUT } from "../app/constants/constants";

const useImageGeneration = () => {
  const [loading, setLoading] = useState(false);
  const [imageLink, setImageLink] = useState<string | null>(null);

  const generateImage = async (recipeName: string) => {
    setLoading(true);
    try {
      const imageResult: any = await axios({ method: 'post', url: IMAGE_GENERATION_API, timeout: RECIPE_CREATION_TIMEOUT, data: { imageTitle: recipeName, imageType: "recipe" } }).catch((err) => {
        throw new Error('Error generating image', err);
      });
      setImageLink(imageResult?.data ?? DEFAULT_RECIPE_CREATION_IMAGE_LINK);
      setLoading(false);
      return imageResult?.data ?? DEFAULT_RECIPE_CREATION_IMAGE_LINK;
    } catch (err) {
      setLoading(false);
      console.error('Error generating image', err)
      return null;
    }
  }

  return { loading, imageLink, generateImage };
}

export default useImageGeneration